<template>
  <v-autocomplete
    v-model="selectedOptionValue"
    :items="modelList"
    clearable
    hide-no-data
    hide-selected
    return-object
    :loading="loading"
    :search-input.sync="searchQuery"
    item-value="id"
    :error="searchQuery && searchQuery.length < 2"
    :append-icon="loading ? '' : 'search'"
    item-text="title"
    label="Поиск регионов (от 2-х букв)"
    persistent-hint
    @click:append="requestData"
    @change="onSelectedModelListListChange"
  />
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import ApiMixin from '@/mixins/api-mixin'

export default {
  name: 'WBDRegionListSelectorFilter',
  mixins: [ApiMixin],
  props: {
    remoteOptionValue: {
      type: String,
    },
    remoteList: {
      type: Array,
    },
    showRaw: {
      type: Boolean,
    },
  },
  data () {
    return {
      loading: false,
      searchQuery: null,
      modelList: [],
      selectedOptionValue: null,
    }
  },
  computed: {
    ...mapGetters({
    }),
  },
  async created () {
    if (this.remoteList && this.remoteList.length) {
      this.modelList = this.remoteList
      this.selectedOptionValue = this.remoteList[0]
    }
    this.eventsBus.$on(this.eventNames.REGION_LIST_FILTER_RESET, () => {
      this.selectedModelList = null
      this.searchQuery = null
    })

    if (!this.modelList.length || !this.selectedOptionValue) {
      await this.requestData(true)
    }
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
    }),
    async requestData () {
      try {
        this.loading = true
        const params = {}

        if (this.searchQuery && this.searchQuery.trim() !== '') {
          params.searchQuery = this.searchQuery
        }
        if (this.showRaw) {
          params.showRaw = '1'
        }

        await this.requestRegionList(this.setRegionList, params)

        setTimeout(() => {
          this.loading = false
        }, 1500)

        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    setRegionList (regionListData) {
      if (regionListData && regionListData.error) {

      } else {
        this.modelList = regionListData.modelList.map((item) => {
          const prefix = item.federalDistrict && item.federalDistrict.id ? '(Все населенные пункты)' : '(СТАРЫЙ)'
          return {
            ...item,
            title: `${item.title} ${prefix}`
          }
        }
        )
      }
    },
    onSelectedModelListListChange () {
      this.$emit(
        'onRegionListSelectorFilterChange',
        this.selectedOptionValue ? this.selectedOptionValue.id : null
      )
    },
  }
}
</script>
